import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Label, Button} from 'reactstrap';
import CreateReportDetails from './CreateReportDetails';
import { Icon } from 'semantic-ui-react';
import { GetWorkOrderBuildingsList } from '../../../../action/workorderAction';

const ErrorSign = {
    color: '#D42D27',
    paddingLeft: '8px',
    paddingTop: '0px',
    paddingRight: '14px',
    width: '22px',
    height: '22px',
    top: '406px',
    left: '959px'
};
const ErrorPadding = {
    color: '#D42D27',
    fontfamily: 'Lato',
    fontStyle: 'italic',
    border: '2px solid #D42D27',
    height: '40px',
    padding: '10px',
    float: 'right',
    marginTop: '-5px'
};

class CreateReports extends Component{
    constructor(props){
        super(props);
        this.state={
            selectedOption: "1",
            isNext: false,
            noBuildingExist: false,
        }
        this.handleReportTypeChange = this.handleReportTypeChange.bind(this);
        this.Redirect_To_CreatePage = this.Redirect_To_CreatePage.bind(this);
        this.redirectToNextPage = this.redirectToNextPage.bind(this);
    }

    Redirect_To_CreatePage(selectedReportType){
        this.setState({isNext:false, selectedOption: selectedReportType});
    }

    handleReportTypeChange(event){
        this.setState({selectedOption: event.target.value, noBuildingExist: false});
    }

    redirectToNextPage(){
        if(this.state.selectedOption === "3"){
            const result = this.props.GetWorkOrderBuildingsList();
            result.then(() => { 
                if((this.props.getWorkOrderBuildings.length === 0) || (this.props.getWorkOrderBuildings.filter(el => el.isDeleted === false).length === 0)){
                        this.setState({noBuildingExist: true, isNext: false});
                }
                else{
                    this.setState({isNext: true})
                }
            });
        }
        else{
            this.setState({isNext:true});
        }
    }

    render(){
        let label = this.props.getLabels;
        var selecterrortext = <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato'}}><b>{label["CreateReport.NoBuildingExist.Text"] !== undefined ? label["CreateReport.NoBuildingExist.Text"]: "There are no buildings in the system. You must add a discovered or non-discovered building to create a building report."}</b></Label>
        var errormsg;
        if (this.state.noBuildingExist) {
            errormsg = <p style={ErrorPadding} >
                <Icon name='exclamation triangle' style={ErrorSign} />
                <b>Please correct all errors before continuing.</b>
            </p>
        }
        return (
            this.state.isNext ? <CreateReportDetails reportType={this.state.selectedOption} Redirect_To_ReportList={this.props.Redirect_To_ReportList} Redirect_To_CreatePage={this.Redirect_To_CreatePage} /> : 
            <div className={this.props.Premise ? "main_container" : "cloud_main_container"}>
                <div className="border_container">
                    <div className="main_container" style={{height:'280px'}} >
                        <div className="row row_padding" style={{margin:'10px 0px 20px 0px' }}>
                            <div className="col-md-12">
                                <Label className="reportsHeaderlbl">Create New Report</Label>
                            </div>
                        </div>
                        <div className="row row_padding" style={{marginLeft: '0px', marginRight: '0px'}} onChange={this.handleReportTypeChange}>
                            <div className="col-md-12" style={{paddingBottom:'5px'}}>
                                <Label className="reportsTextlbl">{label['CreateReport.ChooseReportType.Text'] !== undefined ? label['CreateReport.ChooseReportType.Text'] : "Choose Report Type*"}</Label>
                            </div>
                            <div className="col-md-12" style={{paddingBottom:'5px'}}>
                                <input type="radio" id="reportType1" name="reportType" value="1" defaultChecked={this.state.selectedOption === "1"} style={{marginRight:'5px', verticalAlign:'middle'}} />
                                <Label className="reportsTypelbl">{label['CreateReport.ReportType.1.Text'] !== undefined ? label['CreateReport.ReportType.1.Text'] : "Work Order Records"}</Label>
                            </div>
                            <div className="col-md-12" style={{paddingBottom:'5px'}}>
                                <input type="radio" id="reportType2" name="reportType"value="2" defaultChecked={this.state.selectedOption === "2"} style={{marginRight:'5px', verticalAlign:'middle'}} />
                                <Label className="reportsTypelbl">{label['CreateReport.ReportType.2.Text'] !== undefined ? label['CreateReport.ReportType.2.Text'] : "Preventative Maintenance Records"}</Label>
                            </div>
                            <div className="col-md-12" style={{paddingBottom:'5px'}}>
                                <input type="radio" id="reportType3" name="reportType" value="3" defaultChecked={this.state.selectedOption === "3"} style={{marginRight:'5px', verticalAlign:'middle'}}/>
                                <Label className="reportsTypelbl">{label['CreateReport.ReportType.3.Text'] !== undefined ? label['CreateReport.ReportType.3.Text'] : "Buildings"}</Label>
                                <span style={{marginLeft:'10px'}} hidden={!this.state.noBuildingExist}>{selecterrortext}<Icon name='exclamation triangle' style={ErrorSign} /></span>
                            </div>
                            <div className="col-md-12" style={{paddingBottom:'5px'}}>
                                <input type="radio" id="reportType4" name="reportType" value="4" defaultChecked={this.state.selectedOption === "4"} style={{marginRight:'5px', verticalAlign:'middle'}}/>
                                <Label className="reportsTypelbl">{label['CreateReport.ReportType.4.Text'] !== undefined ? label['CreateReport.ReportType.4.Text'] : "Technicians"}</Label>
                            </div>
                        </div>
                    </div>
                    <div style={{marginBottom:'-50px', position:'relative', height:'30px'}}>
                        <span className="workorderlbl-noentry" style={{position: 'absolute', bottom:'-2px', left:'15px'}}>*required fields </span> 
                        <Button className="reports_btn_cancel" style={{float:'right', marginLeft:'6px', background: '#BBBBBB 0% 0% no-repeat padding-box'}} onClick={() => {this.props.Redirect_To_ReportList()}}>CANCEL</Button>
                        <Button className="btn-success" style={{float:'right', marginLeft:'6px', background: '#61AE34 0% 0% no-repeat padding-box'}} onClick={this.redirectToNextPage} disabled={this.state.noBuildingExist}>NEXT</Button>
                        {errormsg}
                    </div>
                </div>
            </div>
        )
    };
};

const mapStateToProps = (state) => {
    return {
        getWorkOrderBuildings: state.WorkorderRootReducer.WorkorderBuildings,
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
    };
}; 

const mapDispatchToProps = (dispatch) => {
    return {
        GetWorkOrderBuildingsList: () => dispatch(GetWorkOrderBuildingsList()),
    };
};

export default connect(mapStateToProps,mapDispatchToProps) (CreateReports);
